const Pencil = ({ size = 200, color="#959FAF" }) => (
  <svg width={size} height={size} viewBox="0 0 11 11" fill="none">
    <path
      d="M6.01228 2.68135L8.22935 4.89855M9.69466 3.43272L2.63287 10.4945H0.359375V8.22101L7.42116 1.15922C7.47101 1.10896 7.53032 1.06907 7.59566 1.04185C7.661 1.01463 7.73108 1.00061 7.80187 1.00061C7.87265 1.00061 7.94274 1.01463 8.00808 1.04185C8.07342 1.06907 8.13272 1.10896 8.18257 1.15922L9.69466 2.67131C9.74492 2.72116 9.78481 2.78046 9.81203 2.8458C9.83926 2.91114 9.85327 2.98123 9.85327 3.05201C9.85327 3.1228 9.83926 3.19288 9.81203 3.25822C9.78481 3.32357 9.74492 3.38287 9.69466 3.43272Z"
      stroke={color}
      strokeWidth={0.5}
      strokeLinejoin="round"
    />
  </svg>
);
export default Pencil;
